// Match the iframe directly so resizing does not depend on the filter wrapper.
// The URL fallback also supports templates that have not received the new class.
const intentFrames = document.querySelectorAll('iframe.intent-trials-embed, iframe[src^="https://trials.prod.intent.ag/"]');
intentFrames.forEach((frame) => {
 if (frame.dataset.intentResizeInitialized) return;
 frame.dataset.intentResizeInitialized = 'true';
 let reportedHeight = null;
 let resizeTimer;
 let restoreTimer;
 let previousWidth = frame.getBoundingClientRect().width;
 window.addEventListener('message', (event) => {
  if (event.source !== frame.contentWindow) return;
  if (event.origin !== 'https://trials.prod.intent.ag') return;
  if (event.data?.type !== 'intent-embed-resize') return;
  const height = event.data.height;
  if (typeof height !== 'number' || !Number.isFinite(height) || height <= 0) return;
  clearTimeout(restoreTimer);
  reportedHeight = height;
  frame.style.height = `${height}px`;
 });
 // scrollHeight can stay at the iframe viewport height after content gets
 // shorter. Lower the viewport on width growth so Intent can measure again.
 if (typeof ResizeObserver !== 'undefined') {
  const widthObserver = new ResizeObserver(() => {
   const width = frame.getBoundingClientRect().width;
   if (Math.abs(width - previousWidth) < 1) return;
   const grew = width > previousWidth;
   previousWidth = width;
   clearTimeout(resizeTimer);
   if (!grew || reportedHeight === null) return;
   resizeTimer = setTimeout(() => {
    clearTimeout(restoreTimer);
    frame.style.height = '1px';
    restoreTimer = setTimeout(() => {
     frame.style.height = `${reportedHeight}px`;
    }, 2000);
   }, 150);
  });
  widthObserver.observe(frame);
 }
});

intentFrames.forEach((frame) => {
 if (frame.dataset.trialsFiltersApplied) return;
 frame.dataset.trialsFiltersApplied = 'true';
 // Forward filters while preserving the iframe's default embed settings. Without
 // page filters, fall back to the template's configured default query string.
 const filters = window.location.search.replace(/^\?/, '') || frame.dataset.trialsDefaultFilters || '';
 if (!filters) return;
 const resultsUrl = new URL(frame.src);
 const pageParams = new URLSearchParams(filters);
 const embedParams = new URLSearchParams(resultsUrl.search);
 // Intent uses the enrolled-field ID as a path segment for individual trials.
 const trialId = (pageParams.get('trial') || '').trim();
 if (/^[a-zA-Z0-9_-]+$/.test(trialId)) {
  resultsUrl.pathname = `${resultsUrl.pathname.replace(/\/$/, '')}/${trialId}`;
 }
 pageParams.forEach((value, key) => {
  if (key !== 'trial' && !embedParams.has(key)) resultsUrl.searchParams.append(key, value);
 });
 frame.src = resultsUrl.href;
});
